import Swiper, { EffectFade, Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const $ = jQuery;

export default class Swipers {
    constructor(options = null) {}

    init() {
        this.__swiper();
    }

    __swiper() {
        const $swiperBlocks = $(".banners_swiper_block");

        $swiperBlocks.each((index, swiperBlock) => {
            if (!swiperBlock) return;

            const swiperBlockId = $(swiperBlock).attr("id");

            const mainSwiper = new Swiper(`#${swiperBlockId}`, {
                speed: 1000,
                slidesPerView: 1,
                pauseOnMouseEnter: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: false,
                // autoplay: {
                //     delay: 6000, // Delay between slides in milliseconds
                //     disableOnInteraction: false,
                // },
                loop: true,
                modules: [EffectFade, Autoplay, Pagination],
                pagination: {
                    el: `.js-banner-swiper-pagination`,
                    clickable: true,
                },
            });

            // mainSwiper.autoplay.stop();
        });
    }
}
